<div class="container-fluid" style="max-height: 75vh; overflow-y: auto;">

  <div class="row" style="margin: 0px;padding: 0px;">

   <div class="text-center col-sm-12" style="background-color: black;max-width: 98% !important;">
     <h2 style="color: white; text-align: center;">Systems in folder</h2>
  </div>

   <div class="text-center col-sm-12" style="margin: 0px;max-width: 98% !important;">
    <h3 style="margin-bottom: 0px;padding-bottom: 0px;color: rgb(174, 0, 255); text-align: center;font-weight: bold;">
      Units Fetched: {{this.receivedUnits.length}}
    </h3>
  </div>


   <div class="col-sm-12">
     <div style="max-height:75vh;overflow-y:auto;">
       <div>
         <mat-form-field class="col-sm-12">
           <mat-label>Filter</mat-label>
           <input matInput (keyup)="applyFilter($event)" placeholder="Filter value">
         </mat-form-field>
       </div>

       <table mat-table [dataSource]="logsTableData" class="col-sm-12 mat-elevation-z8"
        style="background-color: whitesmoke; table-layout: fixed;">

         <ng-container matColumnDef="icon" >
          <th mat-header-cell *matHeaderCellDef class="px-2"></th>
          <td mat-cell *matCellDef="let element" class="px-2"> <mat-icon aria-hidden="false" >tablet_android</mat-icon> </td>
         </ng-container>

         <ng-container matColumnDef="system_name">
          <th mat-header-cell *matHeaderCellDef class="px-2"> Name </th>
          <td mat-cell *matCellDef="let element" class="px-2"> {{element.system_name?element.system_name:"NA"}} </td>
        </ng-container>

          <ng-container matColumnDef="system_ip">
            <th mat-header-cell *matHeaderCellDef class="px-2"> IP </th>
            <td mat-cell *matCellDef="let element" class="px-2"> <a (click)="goToLink(element)" style="cursor:pointer;text-decoration: underline;">{{element.system_ip}}</a> </td>

          </ng-container>

          <ng-container matColumnDef="parentFolder">
            <th mat-header-cell *matHeaderCellDef class="px-2" > Parent Folder </th>
            <td mat-cell *matCellDef="let element" class="px-2"> {{element.parentFolder?element.parentFolder:"NA"}} </td>
          </ng-container>

          <ng-container matColumnDef="last_monitored_date">
            <th mat-header-cell *matHeaderCellDef class="px-2"> Last Health Check Date</th>
            <td mat-cell *matCellDef="let element" class="px-2"> {{element.last_monitored_date?element.last_monitored_date:"NA"}} </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="px-2">Status</th>
            <td mat-cell *matCellDef="let element" class="px-2" style="font-weight: bold;" [style.color]="returnElementColor(element)"> {{element.status?element.status:"NA"}} </td>
          </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
       <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
       </table>
   </div>

  </div>

</div>
